import { ScheduleCallButton } from '@/components/ScheduleCallButton'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

const LockedAppointmentResults = () => (
	<VStack className="items-center flex-1 justify-center">
		<VStack className="gap-16 lg:max-w-fit max-w-72 items-center">
			<VStack gap={24} className="items-center">
				<Header className="text-center lg:max-w-fit max-w-56">
					Your results are ready.
				</Header>
				<Text className="max-w-[22rem] text-center">
					Book a 15-min call with your clinician to discuss your results and book your
					next visit.
				</Text>
			</VStack>
			<ScheduleCallButton />
		</VStack>
	</VStack>
)

export { LockedAppointmentResults }
